// extracted by mini-css-extract-plugin
export var o_cards_overflow = "cardsOverflow-module--o_cards_overflow--b055e";
export var o_cards_overflow__actions = "cardsOverflow-module--o_cards_overflow__actions--a6e4b";
export var o_cards_overflow__btn = "cardsOverflow-module--o_cards_overflow__btn--9e03d";
export var o_cards_overflow__card = "cardsOverflow-module--o_cards_overflow__card--4bdbd";
export var o_cards_overflow__desc = "cardsOverflow-module--o_cards_overflow__desc--d8c0e";
export var o_cards_overflow__img = "cardsOverflow-module--o_cards_overflow__img--c45fe";
export var o_cards_overflow__info = "cardsOverflow-module--o_cards_overflow__info--614b5";
export var o_cards_overflow__num = "cardsOverflow-module--o_cards_overflow__num--0f4db";
export var o_cards_overflow__title = "cardsOverflow-module--o_cards_overflow__title--75a8d";